import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import {
  Typography,
  Box,
  Card,
  Dialog,
  DialogContent,
  IconButton,
  Button,
} from "@mui/material";
import TabBoxComponent from "components/UI/TabBox";
import VehicleRequests from "./VehicleRequests";
import IncomingVehicleRequests from "./IncomingVehicleRequests";
import DatatableComponent from "../../helpers/DatatableComponent";
import FormDialog from "../../helpers/FormDialog";
import DeleteDialog from "../../helpers/DeleteDialog";
import OpenDocument from "../../helpers/openDocument";
import { getFileMime } from "../../store/helpers/common_functions";
import BootstrapDialogTitle from "../../helpers/BootstrapDialogTitle";
import StatusLayout from "../../components/Status";
import axios from "axios";
import { errorToast, successToast } from "helpers/Notification";
import { useHistory } from "react-router";

function VehicleManagement({ location, SetSelectedMenu, systemSettings }) {
  const mainBackground = systemSettings?.mainBackground;

  const [selectedTab, setSelectedTab] = useState(location?.state?.tab ?? 0);
  const [open, setOpen] = useState(0);
  const [value, setValue] = useState({});
  const [list, setList] = useState([]);
  const [id, setId] = useState();
  const [count, setCount] = useState(0);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [description, setDescription] = useState();
  const [driverOpen, setDriverOpen] = useState(0);
  const [driverValue, setDriverValue] = useState({});
  const [driverList, setDriverList] = useState([]);
  const [driverId, setDriverId] = useState();
  const [driverCount, setDriverCount] = useState(0);
  const [driverDeleteOpen, setDriverDeleteOpen] = useState(false);
  const [driverFileView, setDriverFileView] = useState(null);
  const [driverOpenView, setDriverOpenView] = useState(false);
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedRequestId, setSelectedRequestId] = useState(null);
  const history = useHistory();
  const [availableVehicles, setAvailableVehicles] = useState([]);
  const [loadingVehicles, setLoadingVehicles] = useState(false);
  const [allVehicles, setAllVehicles] = useState([]);

  const fetchEmployees = async () => {
    try {
      const response = await axios.get("/api/driver/employees");
      if (response.data && response.data.data) {
        setEmployees(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const fetchRequests = async () => {
    try {
      const response = await axios.get(
        `/api/vehicle-request/list?status=all&count=${count}&start=0&length=20`
      );
      if (response.data && response.data.data) {
        setList(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching requests:", error);
    }
  };

  const refreshVehicleStatuses = async () => {
    try {
      await axios.post("/api/vehicle/refresh-statuses");
      setCount((prevCount) => prevCount + 1);
    } catch (error) {
      console.error("Error refreshing vehicle statuses:", error);
      errorToast("Failed to refresh vehicle statuses");
    }
  };

  const fetchAvailableVehicles = async () => {
    try {
      setLoadingVehicles(true);
      const response = await axios.get("/api/vehicle/list");
      if (response.data && response.data.data) {
        // setAvailableVehicles(
        //   response.data.data.filter((v) => v.status === "Available")
        // );
      }
    } catch (error) {
      console.error("Error fetching vehicles:", error);
    } finally {
      setLoadingVehicles(false);
    }
  };

  const fetchAllVehicles = async () => {
    try {
      const response = await axios.get("/api/vehicle/list");

      if (response.data && response.data.data) {
        setAllVehicles(response.data.data);

        return response.data.data; // Return the data
      } else {
        console.warn(
          "No vehicles data in response or unexpected format:",
          response.data
        );
        return [];
      }
    } catch (error) {
      console.error("Error fetching vehicles:", error.response || error);
      return [];
    }
  };

  useEffect(() => {
    // Refresh vehicle statuses when component mounts
    refreshVehicleStatuses();
    fetchEmployees();
    fetchAvailableVehicles();
    fetchAllVehicles(); // Add this line to fetch all vehicles

    // Set up an interval to refresh vehicle statuses every 5 minutes
    const intervalId = setInterval(refreshVehicleStatuses, 5 * 60 * 1000);

    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  // useEffect(() => {
  //   fetchRequests();
  // }, [count]);

  useEffect(() => { }, [allVehicles]);

  useEffect(() => {
    if (driverOpen > 0) {
    }
  }, [driverOpen]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const setValue0 = (name, val) => {
    if (!name) return null;
    setValue((v) => ({ ...v, [name]: val }));
  };

  const setDriverValue0 = (name, val) => {
    if (!name) return null;
    setDriverValue((v) => ({ ...v, [name]: val }));
  };

  const onSuccess = () => setCount((v) => v + 1);

  const onDriverSuccess = () => {
    setDriverCount((v) => v + 1);
    setDriverValue({});
  };

  const handleDriverView = (id) => {
    const obj = driverList.find((x) => x.id === id);
    if (obj && obj.attachment) {
      setDriverFileView(obj.attachment);
      setDriverOpenView(true);
      setDescription(obj.names);
    }
  };


  const handleCancelRequest = async () => {
    try {
      await axios.get(`/api/request/cancel/${selectedRequestId}`);
      setOpenCancelDialog(false);
      setSelectedRequestId(null);
      successToast("Request cancelled successfully");
      setCount((v) => v + 1);
    } catch (error) {
      setOpenCancelDialog(false);
      setSelectedRequestId(null);
      errorToast(
        error.response?.data?.message ||
        "Failed to cancel the request. Please try again."
      );
    }
  };

  const handleEditDriver = (driverId) => {
    const obj = driverList.find((x) => x.id === driverId);
    setDriverId(driverId);
    setDriverValue({
      names: obj.names,
      contactNumber: obj.contactNumber,
      licenseCategory: obj.licenseCategory,
      email: obj.email,
      placeOfResidence: obj.placeOfResidence,
      attachment: obj.attachment || [],
      status: obj.status,
      vehicleId: obj.vehicleId || "",
    });

    // Ensure we have vehicles before opening the form
    if (!allVehicles || allVehicles.length === 0) {
      fetchAllVehicles().then(() => {
        setDriverOpen(2);
      });
    } else {
      setDriverOpen(2);
    }
  };

  const vehicleColumns = [
    {
      name: "plateNumber",
      label: "Plate Number",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "model",
      label: "Model",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "type",
      label: "Type",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "color",
      label: "Color",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "vinNumber",
      label: "Vin Number",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          const id = tableMeta.rowData[tableMeta.rowData.length - 1];
          return <StatusLayout status={value} />;
        },
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v, tableMeta) => {
          return (
            <div className="flex items-center">
              <IconButton
                onClick={() => {
                  setId(v);
                  const obj = list.find((x) => x.id === v);
                  setValue({
                    plateNumber: obj.plateNumber,
                    model: obj.model,
                    type: obj.type,
                    color: obj.color,
                    vinNumber: obj.vinNumber,
                    status: obj.status || "Available",
                  });
                  setOpen(2);
                }}
              >
                <img
                  src={require("../../assets/icons/pencil.svg").default}
                  alt="Edit"
                  className="mr-2 text-sm"
                />
              </IconButton>
              <IconButton
                onClick={() => {
                  setId(v);
                  setDeleteOpen(true);
                }}
              >
                <img
                  src={require("../../assets/icons/trash.svg").default}
                  alt="Delete"
                  className="mr-2 text-sm"
                />
              </IconButton>
            </div>
          );
        },
      },
    },
  ];

  const driverColumns = [
    {
      name: "names",
      label: "Names",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "contactNumber",
      label: "Contact Number",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "licenseCategory",
      label: "License Category",
      type: "select",
      value: driverValue["licenseCategory"],
      values: [
        { label: "A", value: "A" },
        { label: "A1", value: "A1" },
        { label: "B", value: "B" },
        { label: "B1", value: "B1" },
        { label: "C", value: "C" },
        { label: "D", value: "D" },
        { label: "D1", value: "D1" },
        { label: "E", value: "E" },
        { label: "F", value: "F" },
      ],
      required: true,
      setValue: (val) => setDriverValue0("licenseCategory", val),
    },
    {
      name: "email",
      label: "Email",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "placeOfResidence",
      label: "Place of Residence",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          const id = tableMeta.rowData[tableMeta.rowData.length - 1];
          return <StatusLayout status={value} />;
        },
      },
    },
    {
      name: "attachment",
      label: "Documents",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (attachments) => (
          <div>
            {attachments && attachments.length > 0 ? (
              <IconButton onClick={() => handleDriverView(attachments)}>
                <i
                  className="fas fa-paperclip"
                  style={{ fontSize: "1.2rem" }}
                ></i>
              </IconButton>
            ) : (
              ""
            )}
          </div>
        ),
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => (
          <div className="flex items-center">
            <IconButton onClick={() => handleDriverView(v)}>
              <img
                src={require("../../assets/icons/eye.svg").default}
                alt="View"
                className="mr-2 text-sm text-blueGray-300"
              />
            </IconButton>
            <IconButton onClick={() => handleEditDriver(v)}>
              <img
                src={require("../../assets/icons/pencil.svg").default}
                alt="Edit"
                className="mr-2 text-sm"
              />
            </IconButton>
            <IconButton
              onClick={() => {
                setDriverId(v);
                setDriverDeleteOpen(true);
              }}
            >
              <img
                src={require("../../assets/icons/trash.svg").default}
                alt="Delete"
                className="mr-2 text-sm"
              />
            </IconButton>
          </div>
        ),
      },
    },
  ];

  useEffect(() => {
    SetSelectedMenu({
      menu: "vehicle-management",
      title: "Vehicle Management",
    });
  }, []);

  return (
    <Card sx={{ margin: "16px 0" }}>
      <Box sx={{ padding: "16px", overflowX: "auto" }}>
        {errorMessage && (
          <Typography color="error" variant="body2" sx={{ mb: 2 }}>
            {errorMessage}
          </Typography>
        )}
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabBoxComponent
            selectedValue={selectedTab}
            handleTabChange={handleTabChange}
            tabList={[
              {
                label: "Vehicle Booking",
                tabValue: 0,
                permissionCode: "menu.vehicle_booking",
              },
              {
                label: "Vehicles",
                tabValue: 1,
                permissionCode: "submenu.vehicle_management",
                // permissionCode: "action.add.vehicle",
              },
              {
                label: "Drivers",
                tabValue: 2,
                permissionCode: "submenu.driver_management",
                // permissionCode: "action.add.vehicle",

              },
              {
                label: "Incoming Vehicle Requests",
                tabValue: 3,
                permissionCode: "submenu.incoming_vehicle_requests",
              },
            ]}
          />
          <hr style={{ border: "0.5px solid #ccc", margin: "10px 0" }} />
        </Box>

        <Box sx={{ mt: 3 }}>
          {selectedTab === 0 && (
            <VehicleRequests systemSettings={systemSettings} />
          )}

          {selectedTab === 1 && (
            <div className="w-full mb-12 px-4">
              <DeleteDialog
                open={deleteOpen}
                setOpen={() => setDeleteOpen(false)}
                onSuccess={onSuccess}
                url={`/api/vehicle/delete/${id}`}
              />
              <FormDialog
                maxWidth={"md"}
                col={6}
                open={open > 0}
                onSuccess={onSuccess}
                setOpen={setOpen}
                url={
                  open === 1
                    ? "/api/vehicle/create"
                    : `/api/vehicle/update/${id}`
                }
                method={open === 1 ? "POST" : "POST"}
                title={open === 1 ? "Add New Vehicle" : "Edit Vehicle"}
                fields={[
                  {
                    name: "plateNumber",
                    label: "Plate Number",
                    value: value["plateNumber"],
                    required: true,
                    setValue: (val) => setValue0("plateNumber", val),
                  },
                  {
                    name: "model",
                    label: "Model",
                    value: value["model"],
                    required: true,
                    setValue: (val) => setValue0("model", val),
                  },
                  {
                    name: "type",
                    label: "Type",
                    value: value["type"],
                    required: true,
                    setValue: (val) => setValue0("type", val),
                  },
                  {
                    name: "ownershipType",
                    label: "Vehicle Ownership",
                    type: "select",
                    value: value["ownershipType"] || "Institutional-owned",
                    values: [
                      {
                        label: "Institutional-owned",
                        value: "Institutional-owned",
                      },
                      { label: "Rental", value: "Rental" },
                    ],
                    required: true,
                    setValue: (val) => setValue0("ownershipType", val),
                  },
                  ...(open === 2
                    ? [
                      {
                        name: "status",
                        label: "Status",
                        type: "select",
                        value: value["status"] || "Available",
                        values: [
                          { label: "Available", value: "Available" },
                          { label: "Maintenance", value: "Maintenance" },
                        ],
                        required: true,
                        setValue: (val) => setValue0("status", val),
                      },
                    ]
                    : []),
                  {
                    name: "color",
                    label: "Color",
                    value: value["color"],
                    required: true,
                    setValue: (val) => setValue0("color", val),
                  },
                  {
                    name: "vinNumber",
                    label: "Vin Number",
                    value: value["vinNumber"],
                    required: false,
                    setValue: (val) => setValue0("vinNumber", val),
                  },
                  {
                    name: "seatCount",
                    label: "Seat Count",
                    type: "select",
                    value: value["seatCount"] || "4",
                    values: [
                      { label: "2", value: "2" },
                      { label: "3", value: "3" },
                      { label: "4", value: "4" },

                      { label: "5", value: "5" },
                      { label: "6", value: "6" },
                      { label: "7", value: "7" },
                      { label: "8", value: "8" },
                      { label: "9", value: "9" },
                      { label: "10", value: "10" },
                      { label: "11", value: "11" },
                      { label: "12", value: "12" },
                      { label: "13", value: "13" },
                      { label: "14", value: "14" },
                      { label: "15", value: "15" },
                      { label: "20", value: "20" },
                      { label: "25", value: "25" },
                      { label: "30", value: "30" },
                    ],
                    required: true,
                    setValue: (val) => setValue0("seatCount", val),
                  },
                ]}
              />

              <DatatableComponent
                onAddNew={() => setOpen(1)}
                processData={(data) => {
                  setList(data.data);
                  return data;
                }}
                elevation={1}
                searchfield={true}
                search={false}
                viewColumns={false}
                columns={vehicleColumns}
                url={`/api/vehicle/list?count=${count}`}
                title="Vehicles"
              />
            </div>
          )}

          {selectedTab === 2 && (
            <div className="w-full mb-12 px-4">
              <DeleteDialog
                open={driverDeleteOpen}
                setOpen={() => setDriverDeleteOpen(false)}
                onSuccess={onDriverSuccess}
                url={`/api/driver/delete/${driverId}`}
              />
              <Dialog
                maxWidth={"md"}
                fullWidth={true}
                open={driverOpenView}
                onClose={() => setDriverOpenView(false)}
              >
                <BootstrapDialogTitle onClose={() => setDriverOpenView(false)}>
                  {description || "Driver Documents"}
                </BootstrapDialogTitle>
                <DialogContent>
                  {driverFileView &&
                    (Array.isArray(driverFileView) ? (
                      driverFileView.map((file, index) => (
                        <OpenDocument
                          key={index}
                          downloadable={true}
                          document={file}
                          name={description || "driver-document"}
                          specialName={file}
                          type={"driver-doc"}
                          mimeType={getFileMime(file)}
                        />
                      ))
                    ) : (
                      <OpenDocument
                        downloadable={true}
                        document={driverFileView}
                        name={description || "driver-document"}
                        specialName={driverFileView}
                        type={"driver-doc"}
                        mimeType={getFileMime(driverFileView)}
                      />
                    ))}
                </DialogContent>
              </Dialog>
              <FormDialog
                maxWidth={"md"}
                col={6}
                open={driverOpen > 0}
                onSuccess={onDriverSuccess}
                setOpen={setDriverOpen}
                url={
                  driverOpen === 1
                    ? "/api/driver/create"
                    : `/api/driver/update/${driverId}`
                }
                title={driverOpen === 1 ? "Add Driver" : "Edit Driver"}
                fields={[
                  {
                    name: "resourceId",
                    label: "Select Existing Employee (Optional)",
                    type: "select",
                    value: driverValue["resourceId"] || "",
                    setValue: (val) => {
                      setDriverValue0("resourceId", val);
                      const selectedEmployee = employees.find(
                        (emp) => emp.id === val
                      );
                      if (selectedEmployee) {
                        setDriverValue0("names", selectedEmployee.names);
                        setDriverValue0(
                          "contactNumber",
                          selectedEmployee.phone || ""
                        );
                        setDriverValue0("email", selectedEmployee.email || "");
                      } else {
                        setDriverValue0("names", "");
                        setDriverValue0("contactNumber", "");
                        setDriverValue0("email", "");
                      }
                    },
                    values: employees.map((emp) => ({
                      value: emp.id,
                      label: emp.names,
                    })),
                  },
                  {
                    name: "names",
                    label: "Names",
                    value: driverValue["names"],
                    required: true,
                    setValue: (val) => setDriverValue0("names", val),
                    disabled: !!driverValue["resourceId"],
                  },
                  {
                    name: "contactNumber",
                    label: "Contact Number",
                    value: driverValue["contactNumber"],
                    required: true,
                    setValue: (val) => setDriverValue0("contactNumber", val),
                  },
                  {
                    name: "email",
                    label: "Email",
                    value: driverValue["email"],
                    setValue: (val) => setDriverValue0("email", val),
                  },
                  {
                    name: "licenseCategory",
                    label: "License Category",
                    type: "select",
                    value: driverValue["licenseCategory"],
                    values: [
                      { label: "A", value: "A" },
                      { label: "A1", value: "A1" },
                      { label: "B", value: "B" },
                      { label: "B1", value: "B1" },
                      { label: "C", value: "C" },
                      { label: "D", value: "D" },
                      { label: "D1", value: "D1" },
                      { label: "E", value: "E" },
                      { label: "F", value: "F" },
                    ],
                    required: true,
                    setValue: (val) => setDriverValue0("licenseCategory", val),
                  },
                  {
                    name: "placeOfResidence",
                    label: "Place of Residence",
                    value: driverValue["placeOfResidence"],
                    setValue: (val) => setDriverValue0("placeOfResidence", val),
                  },
                  {
                    name: "attachment",
                    label: "Driver's License",
                    type: "file-drag",
                    required: false,
                    multiple: true,
                    accept: ".pdf,.doc,.docx,.jpg,.jpeg,.png",
                    value: driverValue["attachment"],
                    setValue: (val) => setDriverValue0("attachment", val),
                  },
                  {
                    name: "vehicleId",
                    label: "Assign Vehicle",
                    type: "select",
                    value: driverValue["vehicleId"] || "",
                    setValue: (val) => {
                      setDriverValue0("vehicleId", val);
                    },
                    values: (() => {
                      return [
                        ...allVehicles.map((v) => ({
                          value: v.id,
                          label: `${v.plateNumber} (${v.model})`,
                        })),
                      ];
                    })(),
                  },
                  {
                    name: "status",
                    label: "Status",
                    type: "select",
                    value: driverValue["status"] || "Active",
                    values: [
                      { label: "Active", value: "Active" },
                      { label: "Unavailable", value: "Unavailable" },
                    ],
                    required: true,
                    setValue: (val) => setDriverValue0("status", val),
                  },
                ]}
              />
              <DatatableComponent
                onAddNew={() => {
                  // Ensure we have vehicles before opening the form
                  if (!allVehicles || allVehicles.length === 0) {
                    fetchAllVehicles().then(() => {
                      setDriverOpen(1);
                    });
                  } else {
                    setDriverOpen(1);
                  }
                }}
                processData={(data) => {
                  if (data && data.data) {
                    // Log a sample driver to verify vehicle data
                    if (data.data.length > 0) {
                    }
                    setDriverList(data.data);
                  }
                  return data;
                }}
                elevation={1}
                columns={driverColumns}
                searchfield={true}
                search={false}
                viewColumns={false}
                url={`/api/driver/list?count=${driverCount}`}
                title={"Drivers"}
              />
            </div>
          )}

          {selectedTab === 3 && <IncomingVehicleRequests />}
        </Box>
      </Box>
      <Dialog
        open={openCancelDialog}
        onClose={() => setOpenCancelDialog(false)}
      >
        <DialogContent>
          <Typography>Do you want to cancel this vehicle request?</Typography>
          <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
            <Button onClick={() => setOpenCancelDialog(false)}>No</Button>
            <Button color="error" onClick={handleCancelRequest}>
              Yes, Cancel
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Card>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(VehicleManagement);
